import { Body, Heading } from '@assembly-js/design-system';
import type { ReactNode } from 'react';

/** The design-system button restyled for destructive actions. */
export const DANGER_BUTTON_CLASS =
  'border-transparent! bg-error-primary! text-white! hover:bg-error-primary/90!';

/** A titled, bordered row for a destructive action, as in Settings' danger zone. */
export function DangerActionCard({
  title,
  body,
  action,
}: {
  title: string;
  body: string;
  action: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-4 rounded border border-solid border-[#e5e7eb] bg-white p-5">
      <div className="min-w-0">
        <Heading
          className="mb-0! leading-5 tracking-[-0.15px] text-[#101828]"
          size="base"
          tag="h2"
        >
          {title}
        </Heading>
        <div className="pt-1">
          <Body
            className="leading-5 tracking-[-0.15px] text-[#6a7282] text-pretty"
            size="base"
            tag="div"
          >
            {body}
          </Body>
        </div>
      </div>
      <div className="shrink-0">{action}</div>
    </div>
  );
}
